<script>
    import Mobilebtn from '../mobilebtn.svelte';
    import {initializeGsapAnimation} from '../../utils';
    import {onMount} from 'svelte';
    let main;
    let ImageDiv;
    let para1;
    let para2;
    let button;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation( main, ImageDiv, [{x: '49vw', scale: 1, duration: 1},
            {top: 'max(-22.794vw,-10.535vh) ', scale: 1, duration: 1}], 3);
        initializeGsapAnimation( main, para1, [{top: 'max(62.636vw, 28.99vh)', duration: 1},
            {top: 'max(32.636vw, 15.109vh)', duration: 1}], 3);
        initializeGsapAnimation( main, para2, [{top: 'max(148.364vw,68.687vh)', duration: 1},
            {top: 'max( 104.364vw, 48.31vh)', duration: 1}], 3);
        initializeGsapAnimation( main, button, [{top: 'max(190vw, 87.962vh)', duration: 1},
            {top: 'max(155vw, 71.75vh)', duration: 1}], 3);
    }
</script>


<div class="bg" bind:this={main}>
    <div class="img3">
        <img id="img3" src="images/performersMobile/img3.svg" alt="" />
    </div>
    <div class="performers3">
        <div class="bg3"  style="" bind:this={ImageDiv}>
            <img id="bg3" src="images/performersMobile/bg3.svg" alt="" />
        </div>
        <div class="sub">Performers & Opus</div>
        <div class="h1">VOICE OVER ARTISTS</div>
        <div class="para1" bind:this={para1}>
            <p>
                No play is complete without dialogs. No character is complete
                without a voice.
            </p>
            <p>
                Our game changer technology enables you to turn your voice into
                an everlasting intellectual property.
            </p>
            <p>
                Whenever a director or producer wants to include it in their end
                production, you get paid without having to step into a studio
                and to memorize a single line.
            </p>
        </div>
        <div class="des" bind:this={para2}>
            We're inviting you to become part of making history, vote on
            important societal issues arising for it and of course, get rewarded
            for your time.
        </div>
        <div class="buttons" bind:this={button}>
            <div class="btn" >
                <Mobilebtn
                    text2="(Voice Over Seats)"
                    bgcolor="black"
                    txtcolor="white"
                    txtcolor2="white"
                    border="solid black 0.234vw"
                    state='Performer'
                />
            </div>
        </div>
    </div>
</div>

<style>
    .buttons {
        position: relative;
        top: max(190vw, 87.962vh);
        left: 28vw;
        z-index: 5;
    }
    .btn {
        position: absolute;
        top: max(3vw, 1.38vh);
    }

    .bg {
        height: max(216.355vw, 100.16vh);
        font-family: "Orbitron";
    }
    .performers3 {
        position: relative;
        font-family: "Orbitron";
        height: max(216.355vw, 100.16vh);
        overflow: hidden;
        top: max(-70vw, -32.407vh);
    }
    .img3 {
        position: relative;
        height: 70.093vw;
        width: 42.103vw;
        top: max(11.916vw, 5.516vh);
    }
    #img3 {
        height: 100%;
        width: 100%;
    }
    .bg3 {
        height: 204.673vw;
        width: 257.477vw;
        left: -128.794vw;
        top: max(12.421vw, 5.750vh);
        transform: scale(1.5);
        z-index: 5;
        position: absolute;
        /* height: 204.673vw;
        width: 257.477vw;
        left: -79.794vw;
        top: 15.421vw;*/
    }
    #bg3 {
        height: 100%;
        width: 100%;
    }
    .sub {
        position: absolute;
        left: 7.29vw;
        top: max(37.019vw, 17.138vh);
        font-size: 2.336vw;
        font-weight: 400;
        line-height: 2.336vw;
        text-align: left;
    }
    .h1 {
        position: absolute;
        font-size: 7.009vw;
        font-weight: 900;
        line-height: 7.009vw;
        letter-spacing: 0.06em;
        text-align: left;
        left: 6.542vw;
        top: max(40.991vw, 18.97vh);
        width: 56vw;
    }
    .para1,
    .des {
        font-family: "Orbitron";
        position: absolute;
        font-size: 2.804vw;
        font-weight: 400;
        line-height: 3.972vw;
        letter-spacing: 0.06em;
        text-align: left;
    }
    .des {
        top: max(148.364vw, 68.687vh);
        font-weight: 600;
        height: 35.748vw;
        width: 30.841vw;
        left: 7.243vw;
    }
    .para1 {
        display: flex;
        top: max(62.636vw, 28.99vh);
        left: 6.645vw;
        width: 41.85vw;
        height: 19.86vw;
        flex-direction: column;
    }
</style>
